export default {"src":"/_next/static/media/Peripheral_Artery_Disease.6ad43706.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};